<template>
  <svg width="30px" height="30px"
       viewBox="0 0 30 30" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/30x30/dashboard/black</title>
    <g id="atoms/icons/30x30/dashboard/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M24,4 C25.6568542,4 27,5.34314575 27,7 L27,23.0540541 C27,24.7109083 25.6568542,26.0540541 24,26.0540541 L6,26.0540541 C4.34314575,26.0540541 3,24.7109083 3,23.0540541 L3,7 C3,5.34314575 4.34314575,4 6,4 L24,4 Z M25,10 L5,10 L5,23.0540541 C5,23.6063388 5.44771525,24.0540541 6,24.0540541 L24,24.0540541 C24.5522847,24.0540541 25,23.6063388 25,23.0540541 L25,10 Z M20.5,13 L20.5,22 L18.5,22 L18.5,13 L20.5,13 Z M23.5,18 L23.5,22 L21.5,22 L21.5,18 L23.5,18 Z M17.5,16 L17.5,22 L15.5,22 L15.5,16 L17.5,16 Z M13.5,20 L13.5,22 L6.5,22 L6.5,20 L13.5,20 Z M12.5,16.5 L12.5,18.5 L6.5,18.5 L6.5,16.5 L12.5,16.5 Z M13.5,13 L13.5,15 L6.5,15 L6.5,13 L13.5,13 Z M24,6 L6,6 C5.44771525,6 5,6.44771525 5,7 L5,8 L25,8 L25,7 C25,6.44771525 24.5522847,6 24,6 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
